import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DocumentService = /** @class */ (function () {
    function DocumentService(http) {
        this.http = http;
    }
    DocumentService.prototype.getDocumentList = function () {
        var URL = cmsApi + '/getDocList_web';
        var body = {};
        // console.log("getDocumentList");
        return this.http.post(URL, body);
    };
    DocumentService.ngInjectableDef = i0.defineInjectable({ factory: function DocumentService_Factory() { return new DocumentService(i0.inject(i1.HttpClient)); }, token: DocumentService, providedIn: "root" });
    return DocumentService;
}());
export { DocumentService };
